import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/ListingPage.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/private/listings`;
	}
	create(e) {
		return this.api.post(n.baseUrl, e);
	}
	delete(e) {
		return this.api.delete(`${n.baseUrl}/${e}`);
	}
	update(e, t) {
		return this.api.put(`${n.baseUrl}/${e}`, t);
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
	listNames(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/names`, e));
	}
	listUrls(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}/urls`, e));
	}
};
export { n as ListingPage };

//# sourceMappingURL=ListingPage.js.map